import { render, staticRenderFns } from "./InputWrapper.vue?vue&type=template&id=5bd9cdea&scoped=true"
import script from "./InputWrapper.vue?vue&type=script&lang=js"
export * from "./InputWrapper.vue?vue&type=script&lang=js"
import style0 from "./InputWrapper.vue?vue&type=style&index=0&id=5bd9cdea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd9cdea",
  null
  
)

export default component.exports